/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleConfig } from '../models/role-config';

@Injectable({
  providedIn: 'root',
})
export class RolesConfigApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getConfigForRoles
   */
  static readonly GetConfigForRolesPath = '/roles';

  /**
   * Fetch the configuration for a user role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigForRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigForRoles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleConfig>>> {

    const rb = new RequestBuilder(this.rootUrl, RolesConfigApiService.GetConfigForRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleConfig>>;
      })
    );
  }

  /**
   * Fetch the configuration for a user role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigForRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigForRoles(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleConfig>> {

    return this.getConfigForRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleConfig>>) => r.body as Array<RoleConfig>)
    );
  }

}
